/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { format } from "date-fns";
import axios from "axios";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import {
  showContaimerLoader,
  userID,
  showStatus,
  encodeValue,
  showPriceValue,
  showLoader,
  hideLoader,
  checkPermission,
} from "../Settings/Settings";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "sale/";
var moduleName = "Jobs";
var qs = require("qs");
var Parser = require("html-react-parser");
class List extends Component {
  constructor(props) {
    super(props);
    const userType = cookie.load('userType') ?? '';
    this.state = {
      userID: userID(),
      userType:userType,
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      selectedItem: "",
      employeeList: [],
      selectedEmp: "",
      assignRemarks: "",
      assignHistory: [],
      amountHistory: [],
      totalAmount: 0,
      activeTab: "form",
      colectamount: "",
      modeofPayment: "",
      paymentreferencenumber: "",
      AllowShowAll: "No",
      completedList: [],
      customerList: [],

      assignEmpID:"",
      assignEmpID_error:"",
      assignCustomerID:"",
      assignCustomerID_error:'',
      assignCustomerDetails:"",
      assignCustomerDetails_error:"",
      salenumber:"",
      assignMessage:"",
      assignMessage_error:"",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadEmployee();
    this.loadCustomer();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
        AllowShowAll: nextProps.AllowShowAll,
      });
    }
  }
  loadEmployee() {
      var urlShringTxt =
        apiUrl + "employee/dropdownlist?&userID=" + this.state.userID;
      axios.get(urlShringTxt, headerconfig).then((res) => {
        if (res.data.status === "ok") {
          this.setState({ employeeList: res.data.result });
        }
      });
  }
  loadCustomer() {
    var urlShringTxt =
      apiUrl + "customer/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        const customerList = res.data.result;
        customerList.push({value:'Other', label:'Other'});
        this.setState({ customerList: res.data.result });
      }
    });
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        category: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + module + "joblist",
    };
    this.props.getListData(params);
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value, [`${name}_error`]:"" });
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeRemarks(saleAssignID, event) {
    var assignHistory = this.state.assignHistory;
    var updassignHistory = [];
    if (assignHistory.length > 0) {
      assignHistory.map((item) => {
        if (saleAssignID === item.ID) {
          updassignHistory.push({ ID: item.ID, remarks: event.target.value });
        } else {
          updassignHistory.push(item);
        }
        return "";
      });
    } else {
      updassignHistory.push({ ID: saleAssignID, remarks: event.target.value });
    }
    this.setState({ assignHistory: updassignHistory });
  }
  handleCheckChange(saleAssignID) {
    var completedList = this.state.completedList;

    if (completedList.indexOf(saleAssignID) >= 0) {
      var index = completedList.indexOf(saleAssignID);
      if (index > -1) {
        completedList.splice(index, 1);
      }
    } else {
      completedList.push(saleAssignID);
    }
    this.setState({ completedList: completedList });
  }
  updateRemarks() {
    var assignHistory = this.state.assignHistory;
    if (assignHistory.length > 0) {
      var postObject = {
        userID: this.state.userID,
        jobRemarks: JSON.stringify(assignHistory),
      };
      showLoader("assignEmp");
      axios
        .post(
          apiUrl + "sale/updateJobRemarks",
          qs.stringify(postObject),
          headerconfig
        )
        .then((res) => {
          hideLoader("assignEmp");
          if (res.data.status === "success") {
            toast.success(res.data.message, { autoClose: 2000 });
          } else if (res.data.status === "error") {
            var errMsg =
              res.data.message !== "" ? Parser(res.data.message) : "";
            if (errMsg !== "") {
              toast.error(res.data.message, { autoClose: 2000 });
            }
          }
        });
    } else {
      toast.error("Please enter any one remarks", { autoClose: 2000 });
    }
  }
  completeJob() {
    console.log(this.state.completedList);
    var completedList = this.state.completedList;
    if (completedList.length > 0) {
      var postObject = {
        userID: this.state.userID,
        completedList: JSON.stringify(completedList),
      };
      showLoader("assignEmp");
      axios
        .post(
          apiUrl + "sale/completeJob",
          qs.stringify(postObject),
          headerconfig
        )
        .then((res) => {
          hideLoader("assignEmp");
          if (res.data.status === "success") {
            toast.success(res.data.message, { autoClose: 2000 });
            this.loadList(this.state.currentPage);
          } else if (res.data.status === "error") {
            var errMsg =
              res.data.message !== "" ? Parser(res.data.message) : "";
            if (errMsg !== "") {
              toast.error(res.data.message, { autoClose: 2000 });
            }
          }
        });
    } else {
      toast.error("Please enter any one job", { autoClose: 2000 });
    }
  }

  createJob() {
    $("#modaldemo1").modal("show");
  }
  createNewJob() {
    const assignEmpID = (this.state.userType==="User")?this.state.userID:this.state.assignEmpID?.value ?? '';
    let error = 0;
    if(assignEmpID==="") {
      this.setState({assignEmpID_error:'Please select employee'});
      error++;
    }
    const assignCustomerID = this.state.assignCustomerID?.value ?? '';
    const assignCustomerDetails = this.state.assignCustomerDetails
    if(assignCustomerID==="") {
      this.setState({assignCustomerID_error:'Please select Customer'});
      error++;
    }else {
      if(assignCustomerID==="Other") {
        if(assignCustomerDetails==="") {
          error++;
          this.setState({assignCustomerDetails_error:"Please enter customer"})
        }
      }
    }
    const assignMessage = this.state.assignMessage;
    if(assignMessage==="") {
      this.setState({assignMessage_error:"Please enter message"})
    }
    

    if(error===0) {
      var postObject = {
        userID:this.state.userID,
        empID:assignEmpID,
        assignCustomerID:(assignCustomerID!=="Other")?assignCustomerID:'',
        assignCustomerDetails:(assignCustomerID==="Other")?assignCustomerDetails:'',
        salenumber:this.state.salenumber,
        assignMessage:this.state.assignMessage
      };
      showLoader("createNewJob");
      axios
        .post(
          apiUrl + "sale/createJob",
          qs.stringify(postObject),
          headerconfig
        )
        .then((res) => {
          hideLoader("createNewJob");
          if (res.data.status === "success") {
            toast.success(res.data.message, { autoClose: 2000 });
            this.setState({assignEmpID:"",
              assignEmpID_error:"",
              assignCustomerID:"",
              assignCustomerID_error:'',
              assignCustomerDetails:"",
              assignCustomerDetails_error:"",
              salenumber:"",
              assignMessage:"",
              assignMessage_error:""
            })
            this.loadList(1);
            $("#modaldemo1").modal("hide");
          } else if (res.data.status === "error") {
            var errMsg =
              res.data.message !== "" ? Parser(res.data.message) : "";
            if (errMsg !== "") {
              toast.error(res.data.message, { autoClose: 2000 });
            }
          }
        }).catch((e)=> {
          hideLoader("createNewJob");
        })
    }

  
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="jobs" />
            <ToastContainer />
            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={"Search " + moduleName}
                                name="name"
                                onChange={this.handleChangeText}
                                value={this.state.name}
                              />
                            </div>
                            <div className="col-md-3">
                              <a
                                href={() => false}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={() => false}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalRecords} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="text-end mb-2">
                                <button
                                  className="btn btn-warning"
                                  style={{ marginRight: "5px" }}
                                  onClick={this.createJob.bind(this)}
                                >
                                  Add New Job
                                </button>
                                <button
                                  className="btn btn-primary "
                                  style={{ marginRight: "5px" }}
                                  onClick={this.updateRemarks.bind(this)}
                                  id="updateRemarks"
                                >
                                  Update Remarks
                                </button>
                                <button
                                  className="btn btn-success mr-2 "
                                  onClick={this.completeJob.bind(this)}
                                  id="completeJob"
                                >
                                  Complete Job
                                </button>
                              </div>
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th>Sale Number</th>
                                      <th>Customer Name</th>
                                      <th>Message</th>
                                      {this.state.AllowShowAll === "Yes" && (
                                        <>
                                          <th>Employee Name</th>
                                          <th>Employee ID</th>
                                          <th>Employee Phone</th>
                                        </>
                                      )}
                                      <th>Remarks</th>
                                      <th>Assign Date</th>
                                      <th>Status</th>
                                      
                                      <th>Closed Date</th>
                                      
                                      <th>Contact Person</th>
                                      <th>Mobile </th>
                                      <th>Email</th>
                                      <th>Address</th>
                                      <th>Branch</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>
                                              {item.assignStatus !==
                                                "Completed" && (
                                                <label className="custom-control custom-checkbox mt-7">
                                                  <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    onChange={this.handleCheckChange.bind(
                                                      this,
                                                      item.assignID
                                                    )}
                                                  />
                                                  <span className="custom-control-label"></span>
                                                </label>
                                              )}
                                            </td>
                                            <td>{item.saleNumber}</td>
                                            <td>{(item.customerName!=="" && item.customerName!==null)?item.customerName:(item.assignCustomerDetails)}</td>
                                            <td>{item.assignMessage}</td>
                                            {this.state.AllowShowAll ===
                                              "Yes" && (
                                              <>
                                                <td>{item.empName}</td>
                                                <td>{item.employeeID}</td>
                                                <td>{item.empPhone}</td>
                                              </>
                                            )}
                                            <td>
                                              {item.assignStatus ===
                                              "Completed" ? (
                                                item.assignRemarks
                                              ) : (
                                                <textarea
                                                  className="form-control"
                                                  placeholder="Please Enter Remarks"
                                                  name="assignRemarks"
                                                  style={{ width: "200px" }}
                                                  onChange={this.handleChangeRemarks.bind(
                                                    this,
                                                    item.assignID
                                                  )}
                                                  rows={5}
                                                  cols={5}
                                                >
                                                  {item.assignRemarks}
                                                </textarea>
                                              )}
                                            </td>
                                            <td>{item.assignDate}</td>
                                            <td>{item.assignStatus}</td>
                                            
                                            <td>{item.assignCompletedOn}</td>
                                            <td>
                                              {(item.customerContactPerson!=="" && item.customerContactPerson!==null)?item.customerContactPerson:item.customerContactPersonb}
                                            </td>
                                            <td>{(item.customerMobile!=="" && item.customerMobile!==null)?item.customerMobile:item.customerMobileb}
                                             </td>
                                            <td>
                                              {(item.customerEmail!=="" && item.customerEmail!==null)?item.customerEmail:item.customerEmailb}
                                             </td>
                                            <td>
                                              {item.customerAddress1}
                                              {item.customerAddress2 !== "" &&
                                                item.customerAddress2 !==
                                                  null && (
                                                  <>, {item.customerAddress2}</>
                                                )}
                                              {item.customerState !== "" &&
                                                item.customerState !== null && (
                                                  <>, {item.customerState}</>
                                                )}
                                              {item.customerPincode !== "" &&
                                                item.customerPincode !==
                                                  null && (
                                                  <> - {item.customerPincode}</>
                                                )}
                                            </td>
                                            <td>
                                              {(item.customerBranch!=="" && item.customerBranch!==null)?item.customerBranch:item.customerBranchb}
                                            </td>
                                            <td>
                                              {showStatus(item.empStatus)}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center"
                                          colSpan={12}
                                        >
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                               <Pagenation
                                  params={{
                                    totalRecords: this.state.totalRecords,
                                    totalPage: this.state.totalPage,
                                    currentPage: this.state.currentPage,
                                  }}
                                  sateValChange={this.sateValChange}
                                />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="modaldemo1">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content modal-content-demo">
              <div className="modal-header">
                <h6 className="modal-title">Create Job</h6>
                <button
                  aria-label="Close"
                  className="btn-close"
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                  <div className="form-row mt-4">
                    {(this.state.userType!=="User") && (
                    <div className="form-group col-md-4">
                      <label className="form-label">
                        Select Engineer<span className="lbl-error">*</span>
                      </label>
                      <Select
                        value={this.state.assignEmpID}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "assignEmpID"
                        )}
                        placeholder="Select Engineer"
                        isClearable={true}
                        options={this.state.employeeList}
                      />
                      {this.state.assignEmpID_error!=="" &&
                        <span className="error">{this.state.assignEmpID_error}</span>
                      }
                    </div>)}
                    <div className="form-group col-md-4">
                      <label className="form-label">
                        Customer<span className="lbl-error">*</span>
                      </label>
                      <Select
                        value={this.state.assignCustomerID}
                        onChange={this.handleSelectChange.bind(this, "assignCustomerID")}
                        placeholder="Select Customer"
                        isClearable={true}
                        options={this.state.customerList}
                      />
                      {this.state.assignCustomerID_error!=="" &&
                        <span className="error">{this.state.assignCustomerID_error}</span>
                      }
                    </div>
                    {this.state.assignCustomerID?.value==="Other" && 
                    <div className="form-group col-md-3">
                      <label className="form-label">
                        Customer Name<span className="lbl-error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Customer Name"
                        name="assignCustomerDetails"
                        autoComplete="off"
                        onChange={this.handleChangeText}
                        value={this.state.assignCustomerDetails}
                      />
                      {this.state.assignCustomerDetails_error!=="" &&
                        <span className="error">{this.state.assignCustomerDetails_error}</span>
                      }
                    </div>}
                    <div className="form-group col-md-3">
                      <label className="form-label">
                        Sale Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Sale Number"
                        name="salenumber"
                        autoComplete="off"
                        onChange={this.handleChangeText}
                        value={this.state.salenumber}
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <label className="form-label">Message<span className="lbl-error">*</span></label>
                      <textarea
                        className="form-control"
                        placeholder="Message"
                        name="assignMessage"
                        onChange={this.handleChangeText}
                        rows="3"
                        defaultValue={this.state.assignMessage}
                      />
                      {this.state.assignMessage_error!=="" &&
                        <span className="error">{this.state.assignMessage_error}</span>
                      }
                    </div>
                  </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={this.createNewJob.bind(this)}
                  id="createNewJob"
                >
                  Create Job
                </button>{" "}
                <button className="btn btn-light" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  var AllowShowAll = "No";
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      AllowShowAll = state.listdata[0].AllowShowAll;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    AllowShowAll: AllowShowAll,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
